<script context="module" lang="ts">
  // Update type with each new component
  export type ModalComponent = typeof DefaultModal;
</script>

<script lang="ts">
  import type { EventDispatcher } from "svelte";
  import { getLocalizedProp } from "../../utils";
  import type { ShopComponentProps } from "../types";
  import DefaultModal from "./variants/DefaultModal.svelte";
    import { capturePHComponentDisplayEvent, capturePHComponentInViewportEvent } from "../../lib/posthog";
    import { modalOpen } from "../store";

  export let componentProps: ShopComponentProps;
  export let dispatch: EventDispatcher<any>;
  export let Component: ModalComponent;

  const locale: string = document.documentElement.lang;

  let modal: HTMLDivElement;

  modalOpen.subscribe((value) => {
    if (value) {
      // Delay this by a few frames to ensure the modal child exists.
      setTimeout(() =>{
        if (modal.children.length > 0) {
          const element = modal.children[0] as HTMLElement;
          capturePHComponentDisplayEvent(element, "modal_displayed");
          capturePHComponentInViewportEvent(element, "modal_in_viewport");
        }
      }, 0)
    }
  });
</script>

<div class="pina-app-modal-adapter" bind:this={modal}>
  <svelte:component
    this={Component}
    {...componentProps}
    header={getLocalizedProp(componentProps.header, locale)}
    howItWorksHeader={getLocalizedProp(componentProps.howItWorksHeader, locale)}
howItWorks={componentProps.howItWorks.map((item) => ({
      ...item,
      header: getLocalizedProp(item.header, locale),
      content: getLocalizedProp(item.content, locale),
    }))}
  moreInfo={getLocalizedProp(componentProps.moreInfo, locale)}
    projectName={getLocalizedProp(componentProps.projectName, locale)}
    projectLocation={getLocalizedProp(componentProps.projectLocation, locale)}
    projectShortLocation={getLocalizedProp(
      componentProps.projectShortLocation,
      locale,
    )}
    projectCertification={getLocalizedProp(
      componentProps.projectCertification,
      locale,
    )}
    projectDescription={getLocalizedProp(
      componentProps.projectDescription,
      locale,
    )}
    projectLink={getLocalizedProp(componentProps.projectLink, locale)}
  />
</div>
